import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loadings';
import { Grid } from 'semantic-ui-react';

class Purchase extends React.Component {

  state = {
    from_date: this.props.fromDate,
    to_date: this.props.toDate,
    openDateDialog: false,
    fullWidth: true,
    maxWidth: 'md',
    maxWidth1: 'xs',
    purchase: []
  }

  componentDidUpdate(props) {
    if (props.partno != this.props.partno || props.brand != this.props.brand) {
      this.get();
    }
  }

  get() {
    this.setState({
      from_date: this.props.fromDate,
      to_date: this.props.toDate
    })
  }

  getDetails() {
    if (this.state.from_date == null || this.state.from_date == undefined || this.state.from_date == '' ||
        this.state.to_date == null || this.state.to_date == undefined || this.state.to_date == '') {
      this.setState({ openDateDialog: true });
      return;
    }
    else {
      this.getPurchaseDetails(this.state.from_date, this.state.to_date);
    }
  }

  getPurchaseDetails(from_date, to_date) {
    let context = this;
    context.setState({ load: true, message: 'Getting Sales Details', openDateDialog: false })
    $.ajax({
      type: 'POST',
      data: { 'partno': context.props.partno, 'brand': context.props.brand,
              'fromdate': from_date, 'todate': to_date },
      url: Server() + 'stockinfo/links/service.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ purchase: data, open: true })
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChanges = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleChanges1 = name => event => {
    this.setState({
      [name]: event.target.value,
    });
    if (name == 'from_date') {
      this.getPurchaseDetails(event.target.value, this.state.to_date);
    }
    else {
      this.getPurchaseDetails(this.state.from_date, event.target.value);
    }
  };

  render() {
    let i = 1;
    return (
      <div>
        <u onClick={this.getDetails.bind(this)} id='pointer' style={{color: '#276EF8'}}>{this.props.service}</u>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Purchase Detail`s</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={3}>
                <input type="date"  id="date" value={this.state.from_date}
                  onChange={this.handleChanges1('from_date')} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
              <input type="date"  id="date" value={this.state.to_date}
                 onChange={this.handleChanges1('to_date')} />
              </Grid.Column>
            </Grid><br/>
            <table id='table' width="100%">
              <tr>
                <th id='th' style={{width: '5%'}}><center>Sino</center></th>
                <th id='th'><center>Customer</center></th>
                <th id='th'><center>Voucher</center></th>
                <th id='th'><center>Qty</center></th>
                <th id='th'><center>Date</center></th>
              </tr>
              { this.state.purchase.map((x) => {
                  return (
                    <tr id='tbody'>
                      <td><center>{i++}</center></td>
                      <td>{x.name}</td>
                      <td>{x.voucher_no}</td>
                      <td><center>{x.stock}</center></td>
                      <td><center>{x.timestamp}</center></td>
                    </tr>
                  )
                })
              }
            </table>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ open: false }) }} color="primary">Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth1}
          open={this.state.openDateDialog} onClose={ () => { this.setState({ openDateDialog: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Enter Date</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <input type="date"  id="date" value={this.state.from_date}
                  onChange={this.handleChanges('from_date')} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
              <input type="date"  id="date" value={this.state.to_date}
                 onChange={this.handleChanges('to_date')} />
              </Grid.Column>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ openDateDialog: false }) }} color="primary">Close</Button>
              { this.state.from_date && this.state.to_date ?
                (
                  <Button onClick={this.getPurchaseDetails.bind(this, this.state.from_date, this.state.to_date)} color="primary">Submit</Button>
                ) :
                (
                  <div></div>
                )
              }
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Purchase;
